'use client'

import React from 'react';
import {useRouter} from "next/navigation";
import {Button} from '@/components/ui/button';

const Fallback = () => {
    const router = useRouter();

    return (
        <div
            className="flex h-full flex-col items-center justify-center min-h-screen dark:bg-slate-950 text-center p-4">
       
            <h1 className="text-4xl font-bold text-gray-800 dark:text-white mb-4">Page Not Found</h1>
            <p className="text-gray-600 dark:text-white mb-3">We&apos;re sorry, but something went wrong. Please try again
                later.</p>
            <div className={`flex gap-2`}>
                <Button onClick={() => router.back()}
                        className="w-[90px] mt-0 bg-blue-500 text-white px-6 py-3 rounded-lg shadow hover:bg-blue-600 transition duration-300"
                >
                    Back
                </Button>
            </div>
        </div>
    );
};

export default Fallback;